/**
 * Format price in Indian currency format (Lakhs and Crores)
 * @param {number|string} price - The price to format
 * @returns {string} - Formatted price string
 */
export const formatPrice = (price) => {
  // Convert string to number if needed
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;

  if (!numPrice || isNaN(numPrice) || numPrice === 0) {
    return 'Price on Request';
  }

  if (numPrice >= 10000000) {
    return `₹${(numPrice / 10000000).toFixed(1)} Cr`;
  } else if (numPrice >= 100000) {
    return `₹${(numPrice / 100000).toFixed(1)} L`;
  }
  return `₹${numPrice.toLocaleString()}`;
};

/**
 * Format area in square feet with proper locale formatting
 * @param {number|string} area - The area to format
 * @returns {string} - Formatted area string
 */
export const formatArea = (area) => {
  const numArea = typeof area === 'string' ? parseFloat(area) : area;
  if (!numArea || isNaN(numArea) || numArea === 0) {
    return '';
  }
  return `${parseInt(numArea).toLocaleString()} sq ft`;
};

/**
 * Get property image with fallback logic
 * @param {object} property - The property object
 * @param {function} getProp - Helper function to get property values
 * @returns {string} - Image URL or placeholder
 */
export const getPropertyImageUrl = (property, getProp = null) => {
  if (getProp) {
    // Use getProp function if provided (for components with snake_case/camelCase handling)
    const images = getProp('images', 'images', []);
    const imageArray = Array.isArray(images)
      ? images
      : (typeof images === 'string' ? JSON.parse(images || '[]') : []);
    const firstImage = imageArray.length > 0 ? imageArray[0] : null;
    return firstImage || getProp('image', 'image', '') || '';
  }

  // Direct property access
  const images = property.images || [];
  const imageArray = Array.isArray(images)
    ? images
    : (typeof images === 'string' ? JSON.parse(images || '[]') : []);
  const firstImage = imageArray.length > 0 ? imageArray[0] : null;
  return firstImage || property.image || '';
};
